<div class="details">
  <div class="row">
    <div class="col-md-6">
      <h4 class="hub-level-1-label">Related Strategies</h4>
      @if (strategyRelations.length) {
        <div class="hub-pill-list">
          @for (relation of strategyRelations; track trackByFn($index, relation)) {
            <span>
              @if (!relation.isPrimary) {
                <a [routerLink]="'/portfolio/' + relation.relatedProject?.projectId"
                class="badge-prio-strategy badge font-size-lg mr-1 mb-1">{{relation.relatedProject?.name}}</a>
              }
            </span>
          }
        </div>
      }

      @if (!strategyRelations.length) {
        <div class="no-relations-warning">
          This Whole System does not have any relations to Strategies.
        </div>
      }


      <h4 class="hub-level-1-label">Related Projects</h4>

      @if (projectRelations.length) {
        <div class="hub-pill-list">
          @for (relation of projectRelations; track trackByFn($index, relation)) {
            <span>
              @if (!relation.isPrimary) {
                <a [routerLink]="'/portfolio/' + relation.relatedProject?.projectId"
                class="badge-prio-strategy badge font-size-lg mr-1 mb-1">{{relation.relatedProject?.name}}</a>
              }
            </span>
          }
        </div>
      }

      @if (!projectRelations.length) {
        <div class="no-relations-warning">
          This Whole System does not have any relations to Projects.
        </div>
      }
    </div>

    <div class="col-md-6">

      <h5 class="hub-level-1-label">Region(s)</h5>

      <ul class="hub-bulleted-list">
        @for (regionName of regionNames; track regionName) {
          <li>
            {{ regionName }}
          </li>
        }
      </ul>

      <h5 class="hub-level-1-label">Division(s)</h5>

      <ul class="hub-bulleted-list">
        @for (divisionName of divisionNames; track divisionName) {
          <li>
            {{ divisionName }}
          </li>
        }
      </ul>

      <h5 class="hub-level-1-label">Business Unit(s)</h5>

      <div class="hub-pill-list">
        @for (bu of projectBusinessUnits; track bu) {
          <span>
            @if (bu.isLeadBusinessUnit) {
              <a>
                <span
                class="badge badge-info font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
              </a>
            }
            @if (!bu.isLeadBusinessUnit) {
              <a>
                <span class="badge badge-info-secondary font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
              </a>
            }
          </span>
        }
      </div>

      <h5 class="hub-level-1-label">Related Program Management</h5>

      @if (programManagementRecords.length) {
        <div>
          @for (pm of programManagementRecords; track pm) {
            <span>
              <a [routerLink]="'/portfolio/' + pm.projectId">
                <span class="badge badge-primary font-size-lg mr-1 mb-1">{{ pm.name }}</span>
              </a>
            </span>
          }
        </div>
      }

      @if (programManagementRecords.length === 0) {
        <div class="no-relations-warning" style="color: #999;">
          A Program Management has not identified this record as part of their portfolio.
        </div>
      }


    </div>

  </div>
</div>
